module.exports = __webpack_public_path__ + "kudos_61.svg?e30b28520224fb9957493ea15f61dfc5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_61.svg
// module id = 163
// module chunks = 0